import React from 'react';
import { Box, Typography, Tooltip, Stack, IconButton, CircularProgress, useTheme } from '@mui/material';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { orderTypesColor } from '../../../../Statics';
import TaskDetails from '../TaskDetails/TaskDetails';
import Skeleton from '@mui/material/Skeleton';
import { motion } from 'framer-motion';
import InboxIcon from '@mui/icons-material/Inbox'; // یا هر آیکون مرتبط دیگه

const DetailsDay = ({ mainData = [], isFetching = false, changeModuleMode = () => { } }) => {
    const MotionBox = motion(Box);
    const theme = useTheme().palette.mode;

    const MAX = 600;

    if (isFetching) {
        return (
            <Box sx={{ width: '100%', px: 10 }}>
                {
                    [{}, {}, {}, {}, {}].map((i) => <Skeleton key={i} animation="wave" height={50} sx={{ mb: 1 }} />)
                }
            </Box>
        );
    }
    const emptyStateVariants = {
        hidden: { opacity: 0, y: 20, scale: 0.95 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 15
            }
        }
    };

    const taskVariants = {
        hidden: { opacity: 0, scale: 0.8, x: -20, filter: "blur(5px)" },
        visible: {
            opacity: 1, scale: 1, x: 0, filter: "blur(0px)",
            transition: { type: "spring", stiffness: 200, damping: 18 }
        },
        hover: {
            scale: 1.05, zIndex: 10,
            boxShadow: "0px 8px 20px rgba(0,0,0,0.3)",
            filter: "brightness(1.2)"
        },
        tap: { scale: 0.95 },
        openGradient: {
            backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
            transition: { duration: 3, repeat: Infinity, ease: "linear" }
        }
    };

    // 2. Variants برای حالت خالی
    // const emptyStateVariants = {
    //     hidden: { opacity: 0, y: 30 },
    //     visible: { 
    //         opacity: 1, y: 0, 
    //         transition: { type: "spring", stiffness: 200 } 
    //     },
    //     floating: {
    //         y: [0, -0, 0],
    //         transition: { duration: 3, repeat: Infinity, ease: "easeInOut" }
    //     }
    // };





    return (
        <Stack sx={{ width: '100%' }}>
            {/* HEADER */}

            <Box sx={{ display: "flex", width: '100%' }}>
                <Box sx={{ width: 66, flexShrink: 0 }} />
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: `repeat(10, 1fr)`,
                        flex: 1,
                        width: '100%',
                    }}
                >
                    {['8', '9', '10', '11', '12', '13', '14', '15', '16', '17'].map(h => (
                        <Box
                            key={h}
                            sx={{
                                textAlign: "start",
                                py: 1,

                                borderBottom: "1px dashed #dd2d2d ",
                                // borderLeft: "1px dashed gray ",

                                borderColor: "gray",
                                // bgcolor: '#f9f9f9'
                            }}
                        >
                            <Typography className="font-num"
                                fontSize={12}
                                fontWeight="bold"
                                sx={{ pl: -0.9 }}
                            >
                                {h}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* ROWS */}
            {mainData && mainData.length > 0 ? (
                mainData.map((designer, i) => (
                    <Box
                        key={designer?.id}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            height: 50,
                            width: '100%',
                            // borderBottom: '1px solid #b94123'
                            // ,bgcolor:'red'
                        }}
                    >
                        {/* avatar */}
                        <Box sx={{ width: 66, display: "flex", alignItems: "center", justifyContent: 'center', flexShrink: 0 }}>
                            <Tooltip title={designer?.designerName || "نام کاربر"} arrow>
                                {designer?.avatar ? (
                                    <IconButton size="small">
                                        <Box
                                            component="img"
                                            src={designer?.avatar}
                                            alt="avatar"
                                            sx={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
                                        />
                                    </IconButton>
                                ) : (
                                    <AccountCircleIcon sx={{ fontSize: 32, color: '#999' }} />
                                )}
                            </Tooltip>
                        </Box>

                        {/* timeline */}
                        <Box
                            sx={{
                                flex: 1,
                                position: "relative",
                                height: 30,
                                bgcolor: theme === 'light' ? '#E0E0E0' : '#2224273b', // یا هر رنگ دیگری که مد نظرتان است
                                backgroundImage: theme === 'light'
                                    ? 'linear-gradient(to right, rgba(0, 0, 0, 0.28) 1px, transparent 1px)' // خطوط تیره ملایم برای تم روشن
                                    : 'linear-gradient(to right, rgba(255, 255, 255, 0.29) 1px, transparent 1px)', // خطوط روشن بسیار شفاف برای تم تاریک
                                backgroundSize: '10% 100%',
                                boxShadow: `
    inset 0px 4px 8px -1px rgba(0, 0, 0, 0.6),  /* سایه عمیق از بالا */
    inset 0px -4px 6px -3px rgba(0, 0, 0, 0.4)  /* سایه ملایم از پایین */
`,

                                borderRadius: 3, // گرد کردن گوشه‌ها (اختیاری)
                            }}
                        >
                            {designer.items?.map((item, i) => {

                                const leftPercent = (item.position / MAX) * 100;
                                const widthPercent = (item.value / MAX) * 100;

                                return (
                                    <>


                                        <TaskDetails
                                            key={item.orderId}
                                            item={item}
                                            hasMainPrice={true}
                                            changeModuleMode={changeModuleMode}
                                            onClick={() => setSelectedId(item?.isOpen ? null : item.orderId)}
                                            component={motion.div}
                                            variants={taskVariants}
                                            initial="hidden"
                                            animate={item?.isOpen ? ["visible", "openGradient"] : "visible"}
                                            whileHover="hover"
                                            whileTap="tap"
                                            layout
                                            sx={{
                                                position: "absolute",
                                                left: `${leftPercent}%`,
                                                width: `${widthPercent}%`,
                                                top: '10%',
                                                height: "80%",
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                                display: "flex", alignItems: "center", px: 1,
                                                fontSize: 10, color: 'white', zIndex: item?.isOpen ? 50 : 2,
                                                overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',

                                                // منطق گرادینت زنده
                                                bgcolor: item?.isOpen ? 'transparent' : (item?.colorCode || '#3f51b5'),
                                                backgroundImage: item?.isOpen
                                                    ? 'linear-gradient(270deg, #ff0080, #7928ca, #3a7bd5, #ff0080)'
                                                    : 'none',
                                                backgroundSize: '300% 300%',
                                                boxShadow: item?.isOpen
                                                    ? "0px 0px 15px rgba(121, 40, 202, 0.7)"
                                                    : "inset 0px 2px 4px rgba(0,0,0,0.3)",
                                                // border: item?.isOpen  ? '1px solid white' : 'none'
                                            }}
                                        />


                                    </>


                                );
                            })}
                        </Box>
                    </Box>
                ))
            ) : (
                <MotionBox
                    variants={emptyStateVariants}
                    initial="hidden"
                    animate={["visible", "floating"]} // ترکیب هر دو انیمیشن
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 10,
                        px: 4,
                        borderRadius: '24px',
                        bgcolor: 'rgba(255, 255, 255, 0.03)', // پس‌زمینه بسیار ملایم
                        border: '1px dashed rgba(255, 255, 255, 0.1)', // کادر نقطه‌چین مدرن
                        backdropFilter: 'blur(8px)',
                        textAlign: 'center'
                    }}
                >
                    {/* یک آیکون کمرنگ برای وزن بصری */}
                    <InboxIcon sx={{ fontSize: 50, mb: 2, opacity: 0.2, color: 'red' }} />

                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: 300,
                            color: 'red',
                            letterSpacing: '0.5px',
                            textShadow: '0px 4px 10px rgba(0,0,0,0.1)'
                        }}
                    >
                        در این روز کارکردی ثبت نشده است.
                    </Typography>

                    {/* یک المان تزیینی کوچک زیر متن */}
                    <Box sx={{
                        width: 40,
                        height: 4,
                        bgcolor: 'red',
                        borderRadius: 2,
                        mt: 2,
                        opacity: 0.5
                    }} />
                </MotionBox>
            )}
        </Stack>
    )
}

export default DetailsDay;